import { render } from "./VsudSpinnerSmall.vue?vue&type=template&id=57d1cbce"
import script from "./VsudSpinnerSmall.vue?vue&type=script&lang=js"
export * from "./VsudSpinnerSmall.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ibrahimisa/Documents/Work/HibSoft/Projects/Frontier-Systems/Projects/geomaps-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__